import { Stack, Table, TableBody, TableContainer } from '@mui/material';
import { TableProps } from './TransactionsTable';
import { TableFlexOverflowContainer } from '@/components';
import { TicketsTableHead } from './TicketsTableHead';
import { TicketsOptionHead } from './TicketsOptionHead';
import { TicketsList } from './TicketsList';

export const TicketsTable = ({ value, index }: TableProps) => {
  return (
    <Stack display={value !== index ? 'none' : 'block'}>
      <TicketsOptionHead />
      <TableFlexOverflowContainer>
        <TableContainer>
          <Table stickyHeader>
            <TicketsTableHead />
            <TableBody>
              <TicketsList />
            </TableBody>
          </Table>
        </TableContainer>

        {/* <UsersPagination /> */}
      </TableFlexOverflowContainer>
    </Stack>
  );
};
